export default "__VITE_ASSET__DURUCzGn__"